<template>
  <div class="lookup-page">
    <v-card class="lookup-card">
      <div class="lookup-header">
        <div class="lookup-header__copy">
          <div class="lookup-title">Facilities</div>
          <div class="lookup-subtitle">Manage facilities, locations, and types.</div>
        </div>
        <v-text-field
            v-model="search"
            class="lookup-search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-btn
            v-if="canCreateUserFacilities"
            class="lookup-add-button"
            depressed
            @click="addUserFacilities()"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Facility</span>
        </v-btn>
      </div>
      <v-data-table :headers="headers" :items="Facilities.rows" :loading="loading" :options.sync="options"
                    :search="search"
                    :server-items-length="Facilities.count" class="lookup-table elevation-1"
                    loading-text="Loading... please wait">
        <template v-slot:[`item.name`]="{ item }">
          <label for="item">{{ item.name ? item.name : "-" }}</label>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <label for="item">{{ item.code ? item.code : "-" }}</label>
        </template>
        <template v-slot:[`item.region.name`]="{ item }">
          <label for="item">{{ item.region ? item.region.name : "-" }}</label>
        </template>
        <template v-slot:[`item.facilityType.name`]="{ item }">
          <label for="item">{{ item.facilityType ? item.facilityType.name : "-" }}</label>
        </template>
        <template v-if="canEditUserFacilities" v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon class="mr-2 lookup-action-icon" @click="editUserFacility(item)"
                      v-on="on">mdi-circle-edit-outline
              </v-icon>
            </template>
            <span>{{ title }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="getColor(item.isActive)" dark>
            {{ item.isActive == true ? "Active" : "Not Active" }}
          </v-chip>
        </template>

      </v-data-table>

    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="70%">
        <v-card class="lookup-dialog-card">
          <v-card-title class="lookup-dialog__title" primary-title>{{ title }}

            <v-spacer></v-spacer>

            <v-btn class="lookup-dialog__close" color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <AddUserFacility v-if="dialog" :userFacility="userFacility"
                           @close="closeDialog()" @registerOrUpdateUserFacility="registerOrUpdateUserFacility">
          </AddUserFacility>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import {getUser} from "@/utils/helper";
import {LookupService} from "../../../common/api.service";
import AddUserFacility from "./add-user-facility.vue";
import {UserFacilitiesService} from "./userFacility.service";

export default {
  components: {
    AddUserFacility
  },
  data() {
    return {
      search: "",
      searchDebounce: null,
      loading: false,
      headers: [
        {text: "Facility's Name", value: "name"},
        {text: "Facility's Code", value: "code"},
        {text: "Facility's Location", value: "region.name"},
        {text: "Facility Type", value: "facilityType.name"},
        {text: "Facility's Status", value: "isActive"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      Facilities: [],
      userFacility: null,
      dialog: false,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },

    }
  },
  computed: {
    canCreateUserFacilities() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Facilities" &&
              permission.canCreate
      );
    },
    canEditUserFacilities() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Facilities" &&
              permission.canUpdate
      );
    },
  },
  async beforeMount() {
    this.fetchUserFacilities();
  },
  watch: {
    options: {
      handler() {
        this.fetchUserFacilities();
      },
      deep: true,
    },
    search: function (val) {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchUserFacilities();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchUserFacilities();
      }, 400);
    },
  },
  methods: {
    async fetchUserFacilities() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const res = await LookupService.getAllUserFacilitiesWP(
          page,
          itemsPerPage,
          this.search
      );
      if (res.status === 200) {
        this.loading = false;
        this.Facilities = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching user Facilities, Please try Again!"
        );
      }
    },
    addUserFacilities() {
      this.userFacility = null;
      this.dialog = true;
      this.title = "Add Facility";
    },
    editUserFacility(item) {
      this.userFacility = item;
      this.dialog = true;
      this.title = "Edit Facility";
    },
    closeDialog() {
      this.dialog = false;
      this.fetchUserFacilities();
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
    async registerOrUpdateUserFacility(userFacility) {
      this.loading = true;
      let res = null;

      if (userFacility.editMode) {
        res = await UserFacilitiesService.update(
            userFacility.id,
            userFacility
        );

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchUserFacilities();
              this.loading = false;
              break;
            case 500:
              this.$toast.error(res.data.message);
              this.loading = false;
              break;
          }
        } else {
          this.$toast.error(
              "Unable to update user Facilities, please try again"
          );
          this.loading = false;
        }
      } else {
        res = await UserFacilitiesService.create(userFacility);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchUserFacilities();
              this.loading = false;

              break;
            case 500:
              this.$toast.error(res.data.message);
              this.loading = false;

              break;
          }
        } else {
          this.$toast.error(
              "Unable to create user Facilities, please try again"
          );
          this.loading = false;
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.lookup-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: 100%;
}

.lookup-card {
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.lookup-header {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(240px, 360px) auto;
  align-items: center;
  gap: 16px;
  padding: 24px 28px;
}

.lookup-header__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lookup-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}

.lookup-subtitle {
  font-size: 14px;
  color: #475569;
}

.lookup-search {
  width: 100%;
  max-width: 360px;
  justify-self: center;
  align-self: center;
}

.lookup-table {
  border-radius: 0 0 12px 12px;
}

.lookup-dialog-card {
  border-radius: 10px;
  overflow: hidden;
}

.lookup-dialog__title {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #3a4f63;
  color: #ffffff;
  padding: 20px 24px;
}

.lookup-dialog__close {
  color: #ffffff !important;
}

.lookup-dialog__close .v-icon {
  color: #ffffff !important;
}

.lookup-add-button {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 600;
}

.lookup-action-icon {
  color: #1976d2 !important;
}

@media (max-width: 700px) {
  .lookup-page {
    padding: 12px;
  }

  .lookup-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
  }

  .lookup-search {
    max-width: 100%;
  }

  .lookup-add-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
